export const faq = {
  badge: "FAQ",
  title: "Συχνές ερωτήσεις",
  subtitle: "Όλα όσα πρέπει να γνωρίζετε για το DONKEY TRAVEL",
  items: {
    q1: {
      question: "Πώς λειτουργεί το σύστημα Νύχτες;",
      answer:
        "Είναι μια άμεση ανταλλαγή μεταξύ δύο ιδιοκτητών. Συμφωνείτε για τις ημερομηνίες (ταυτόχρονες ή ετεροχρονισμένες) και τους όρους. Όχι πόντοι, όχι περίπλοκοι υπολογισμοί, μόνο ανθρώπινη επαφή.",
    },
    q2: {
      question: "Πρέπει να ανταλλάξω ταυτόχρονα;",
      answer:
        "Όχι! Αυτό είναι το πλεονέκτημα του ευέλικτου συστήματός μας. Μπορείτε να φιλοξενήσετε τον Γιάννη τον Απρίλιο και να πάτε σε αυτόν τον Οκτώβριο. Αυτό επιτρέπει επίσης να συναντηθείτε κατά την παράδοση των κλειδιών!",
    },
    q3: {
      question: "Πώς επαληθεύονται τα μέλη;",
      answer:
        "Όλα τα μέλη πρέπει να είναι επαληθευμένοι ιδιοκτήτες Airbnb. Επαληθεύουμε επίσης την ταυτότητα, το κατάλυμα και τις κριτικές Airbnb κάθε μέλους για να εγγυηθούμε την ασφάλεια της κοινότητας.",
    },
    q4: {
      question: "Τι συμβαίνει σε περίπτωση προβλήματος;",
      answer:
        "Η ομάδα υποστήριξής μας είναι διαθέσιμη 7/7 για να σας συνοδεύσει. Επιπλέον, το σύστημα αξιολόγησής μας επιτρέπει τη διατήρηση μιας κοινότητας εμπιστοσύνης και τη γρήγορη επίλυση τυχόν προβλημάτων.",
    },
    q5: {
      question: "Υπάρχουν κρυφές χρεώσεις;",
      answer:
        "Όχι, καμία κρυφή χρέωση. Πληρώνετε μόνο την ετήσια συνδρομή σας ανάλογα με την επιλεγμένη γεωγραφική ζώνη. Οι ανταλλαγές είναι στη συνέχεια εντελώς δωρεάν, χωρίς προμήθεια ή επιπλέον έξοδα.",
    },
    q6: {
      question: "Μπορώ να επιλέξω ποιος μένει στο σπίτι μου;",
      answer:
        "Απολύτως! Έχετε τον πλήρη έλεγχο. Μπορείτε να δείτε τα προφίλ, να διαβάσετε τις κριτικές και να αποδεχτείτε ή να απορρίψετε κάθε αίτημα ανταλλαγής σύμφωνα με τις προτιμήσεις σας.",
    },
    q7: {
      question:
        "Είναι ασφαλισμένο το σπίτι μου κατά τη διάρκεια των ανταλλαγών;",
      answer:
        "Ναι, όλες οι ανταλλαγές καλύπτονται από την ασφάλεια του συνεργάτη μας. Επιπλέον, συνιστούμε να ελέγξετε την ασφάλεια κατοικίας σας για βέλτιστη προστασία.",
    },
    q8: {
      question: "Πόσο καιρό πριν πρέπει να κάνω κράτηση;",
      answer:
        "Αυτό εξαρτάται από κάθε ιδιοκτήτη. Κάποιοι δέχονται κρατήσεις της τελευταίας στιγμής, άλλοι προτιμούν να προγραμματίζουν μήνες νωρίτερα. Συνιστούμε να κάνετε κράτηση τουλάχιστον 2-3 εβδομάδες πριν.",
    },
  },
  cta: {
    title: "Έχετε άλλες ερωτήσεις;",
    subtitle:
      "Η ομάδα μας είναι εδώ για να σας βοηθήσει να ξεκινήσετε την περιπέτειά σας στο DONKEY TRAVEL",
    button: "Επικοινωνήστε μαζί μας",
  },
};
